<div class="horizontal-container center-children">
    <div class="fill right-buffer">
        <status-icon [equipment]="item" [clickable]="false"></status-icon>
    </div>
    <div class="fill vertical-container">
        <div class="wrap-overflow">
            {{ item.equipmentType.make }} {{ item.equipmentType.model }}
        </div>
        <div class="wrap-overflow">SN: {{ item.manufacturerSerialNumber }}</div>
        <div *ngIf="showCustodian" class="wrap-overflow">
            Custodian:
            {{ item.custodian | formatOrganisation | defaultTo: 'Owner' }}
        </div>
    </div>
</div>
